import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TextButton from 'LuxKit/Button/TextButton'
import { InverseOutlineTextButton } from 'LuxKit/Button/OutlineTextButton'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalContext from 'contexts/ModalContext'
import BusinessTravellerRequestDemoModal from 'businessTraveller/components/demo-form/BusinessTravellerRequestDemoModal'
import { rem } from 'polished'
import React, { useCallback, useContext } from 'react'
import styled from 'styled-components'
import { BUSINESS_TRAVELLER_BUSINESS_SIGNUP_ROUTE } from 'components/App/Routes/routeConstants'

const SectionPane = styled(Pane)`
  background: linear-gradient(140deg, rgba(255, 255, 255, 0.10) 7.04%, rgba(255, 255, 255, 0.00) 49.89%);
`

const SectionInner = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaQueryUp.tablet} {
    padding-top: ${rem(56)};
    padding-bottom: ${rem(56)};
  }
`

function BusinessTravellerReadySection() {
  const showModal = useContext(ModalContext)
  const openDemoModal = useCallback(() => {
    showModal(<BusinessTravellerRequestDemoModal />)
  }, [showModal])

  return <SectionPane paletteType="inverse">
    <SectionInner>
      <Group direction="vertical" gap={16} tabletHorizontalAlign="center">
        <Heading variant="heading2" align="center" style={{ lineHeight: rem(34) }}>
          Ready to take control of your business travel?
        </Heading>
        <Group direction="vertical" gap={32} tabletHorizontalAlign="center">
          <BodyText variant="large" align="center">
            Get started in minutes or book a personalised demo with our team.
          </BodyText>
          <Group direction="vertical" gap={16} tabletDirection="horizontal" tabletHorizontalAlign="center">
            <TextButton kind="primary" size="medium" fit="mobile-full-width" to={BUSINESS_TRAVELLER_BUSINESS_SIGNUP_ROUTE}>
              Get started for free
            </TextButton>
            <InverseOutlineTextButton kind="secondary" size="medium" onClick={openDemoModal} fit="mobile-full-width">
              Book a free demo
            </InverseOutlineTextButton>
          </Group>
        </Group>
      </Group>
    </SectionInner>
  </SectionPane>
}

export default BusinessTravellerReadySection
